import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { generateRandomId as S } from "@kds-web/common";
import { IconButton as C } from "@kds-web/icon-button";
import { DismissIcon as E } from "@kds-web/icons";
import { cva as K } from "class-variance-authority";
import x from "clsx";
import { forwardRef as O, useRef as b, useState as X, useEffect as y } from "react";
const Y = K(
  [
    "max-h-[80vh] flex-col rounded-medium bg-surface p-none",
    // Display modal when opened
    "hidden opacity-[0] open:flex open:opacity-[1]",
    // Backdrop
    "backdrop:bg-dim backdrop:opacity-high",
    // Forced-colors
    "box-border border-4 border-solid border-surface"
  ],
  {
    variants: {
      size: {
        small: "w-[480px]",
        medium: "w-[672px]",
        large: "w-[864px]"
      }
    },
    defaultVariants: {
      size: "medium"
    }
  }
), $ = O(function({
  id: g,
  open: t = !1,
  title: n,
  titleIcon: f,
  size: k,
  className: w,
  onClose: r,
  children: v,
  actions: N,
  actionsOrientation: z = "horizontal",
  withHeader: I = !0,
  withFooter: R = !0,
  fullWidthContent: j = !1,
  ...B
}, m) {
  const u = b(g ?? S("modal")), [a, p] = X(t), h = b(null), l = typeof m != "function" && m || h;
  y(() => {
    p(t);
  }, [t]), y(() => {
    var i, c;
    const e = document.body;
    return e.style.overflow = a ? "hidden" : "", a ? (i = l.current) == null || i.showModal() : (c = l.current) == null || c.close(), () => {
      e.style.overflow = "";
    };
  }, [a, l]);
  function s() {
    p(!1), r == null || r();
  }
  function D(e) {
    if (e.target !== l.current)
      return;
    const i = e.target.getBoundingClientRect();
    (e.clientY < i.top || e.clientX < i.left || e.clientX > i.right || e.clientY > i.bottom) && s();
  }
  function M(e) {
    e.key === "Escape" && s();
  }
  return (
    // Both the `onClick` and `onKeyDown` events are used to close the modal.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ o(
      "dialog",
      {
        ref: l,
        "aria-modal": "true",
        className: Y({ size: k, className: w }),
        onClick: D,
        onKeyDown: M,
        "aria-labelledby": n ? `${u.current}-title` : void 0,
        ...B,
        children: /* @__PURE__ */ d("div", { className: "flex min-h-full flex-col", children: [
          I && /* @__PURE__ */ d("header", { className: "flex min-h-fit shrink-0 items-center justify-between p-medium", children: [
            n && /* @__PURE__ */ d("div", { className: "flex items-center gap-xsmall", children: [
              f && f,
              /* @__PURE__ */ o(
                "h2",
                {
                  className: "m-none text-title3 text-onSurface",
                  id: `${u.current}-title`,
                  children: n
                }
              )
            ] }),
            /* @__PURE__ */ o(
              C,
              {
                variant: "ghost",
                size: "small",
                label: "Schließen",
                icon: /* @__PURE__ */ o(E, {}),
                onClick: s
              }
            )
          ] }),
          /* @__PURE__ */ o(
            "div",
            {
              className: x(
                "flex-1 overflow-y-auto overscroll-contain",
                "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-accent",
                !j && "p-medium"
              ),
              tabIndex: 0,
              children: v
            }
          ),
          R && /* @__PURE__ */ o(
            "footer",
            {
              className: x(
                "flex min-h-fit shrink-0 justify-end p-medium *:m-none",
                z === "horizontal" ? "flex-wrap gap-medium" : "flex-col gap-xsmall *:w-full"
              ),
              children: N
            }
          )
        ] })
      }
    )
  );
});
$.displayName = "Modal";
export {
  $ as Modal,
  $ as default
};
